import React from 'react';
import { Link } from '@reach/router';
import BackLink from '../../components/BackLink';
import boomerItemsImage from '../../images/boomer_admin_items.png';
import styles from './BoomerItems.module.scss';
import { BOOMER_ITEM_CATEGORIES } from './categories';

const BoomerItems = () => {
    return (
        <>
            <div className={styles.sectionHeader}>
                <div className={styles.titleContainer}>
                    <h1 className={styles.headerTitle}>
                        Overview/Boomer Items
                    </h1>
                    <img
                        className={styles.headerImage}
                        src={boomerItemsImage}
                        alt='Boomer Items'
                    />
                </div>
                <BackLink to='/' text='Back' />
            </div>

            <div className={styles.itemsWrapper}>
                {BOOMER_ITEM_CATEGORIES.map((item) => (
                    <Link
                        key={item.key}
                        to={`/boomerItems/${item.key}`}
                        className={`${styles.itemCard} ${styles.categoryCard}`}
                    >
                        <img
                            className={`${styles.itemImage} ${
                                item.rounded ? styles.roundedImage : ''
                            }`}
                            src={item.image}
                            alt={item.name}
                        />
                        <p className={styles.itemName}>{item.name}</p>
                    </Link>
                ))}
            </div>
        </>
    );
};

export default BoomerItems;
